var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"services"},on:{"click":_vm.closeNav}},[_c('dama-services')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }